import { Alert, Stack, Typography } from "@mui/material";
import { useAuth } from "../../auth/context";
import Logo from "./Logo";
import InstallPwaButton from "../../utils/InstallPwaButton";
import NewPatientButton from "./NewPatientButton";
import  NewOrderAndNewPrescription  from "./mainOptions";
import SearchBar from "./SearchBar";
import { TestEnvironmentChip } from "../../utils";
import { useCreatableDocumentTypes } from "../utils/medicalDocument/documentTypes";

const Home = () => {
  const { user } = useAuth();
  // A doctor who can't create any document type yet is one whose profession api hasn't validated
  // against SISA (every validated profession can at least create orders). Keyed on scopes rather
  // than on `profession === null`, so this only shows up once api actually restricts by profession.
  const isPendingVerification = useCreatableDocumentTypes().length === 0;

  return (
    <Stack flexDirection="column" justifyContent="space-between" height="100%" width="100%">
      <Stack display="flex" flexDirection="column" justifyContent="center" spacing={5} p="2rem">
        <Stack>
          <SearchBar />
        </Stack>

        <Stack
          direction={{ xs: "column", md: "row" }}
          alignItems="flex-start"
        >
          <Stack>
            <Typography variant="h5" sx={{ color: "primary.main" }}>
              Hola, <strong>{`${user.name} ${user.surname}`}</strong>
            </Typography>

            <Stack direction="row" columnGap={1.5} rowGap={0.5} alignItems="center" flexWrap="wrap" mt={1}>
              {!isPendingVerification && (
                <Typography variant="body1" color="text.black" fontSize={16}>
                  Elegí una opción para comenzar
                </Typography>
              )}
              <TestEnvironmentChip />
            </Stack>
          </Stack>
          <Logo />
        </Stack>

        {isPendingVerification && (
          <Alert severity="info">
            Tu cuenta está en proceso de verificación. Mientras tanto, no podés emitir recetas ni órdenes.
          </Alert>
        )}

        <Stack direction={{ xs: "column", sm: "row" }}>
          <NewOrderAndNewPrescription />
        </Stack>
      </Stack>
      <NewPatientButton />
      <InstallPwaButton />
    </Stack>
  );
};

export default Home;
